<section class="content-header">
  <div class="content-header">
     <div class="container-fluid">
       <div class="row mb-2">
         <div class="col-sm-6">
             <h3>Manage Reorder Levels By Grade & Fuel</h3>
         </div>
         <div class="col-sm-6">
           <ol class="breadcrumb float-sm-right">
             <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
             <li class="breadcrumb-item active">Manage Reorder Levels By Grade & Fuel</li>
           </ol>
         </div><!-- /.col -->
       </div><!-- /.row -->
     </div><!-- /.container-fluid -->
  </div>
</section>
<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Manage Reorder Levels By Grade & Fuel</h3>
        <!--Error Message-->
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
           <span [innerHTML]="errorMessage"></span>
         </div>
         <!--Success Message-->
         <div class="alert alert-success" role="alert" *ngIf="successMessage">
           {{successMessage}}
         </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="submit()" class="mb-4">
          <div class="row g-3">
            <div class="col-md-4">
              <div class="form-group">
                  <label>Make:</label>
                  <select formControlName="make_id" class="form-control" (change)="onSelectChange($event.target)">
                      <option value="">Select</option>
                      <option [value]="make.id" *ngFor="let make of makes">{{make.make_name}}</option>
                  </select>
              </div>
            </div>

            <div class="col-md-4">
                <label class="form-label">Model<span style="color:red;">*</span></label>
                <select formControlName="model_id" class="form-control" (change)="onSelectModelChange($event.target)">
                  <option value="">Select</option>
                  <option [value]="model.id" *ngFor="let model of models">{{ model.model_name }}</option>
                </select>
                <span *ngIf="submitted && form.get('model_id')?.hasError('required')" style="color:red"> <strong>Please select vehicle model!</strong></span>
            </div>

            <div class="col-md-4">
              <label class="form-label">Grade</label>
              <select formControlName="grade_id" class="form-control">
                <option value="">Select</option>
                <option [value]="grade.id" *ngFor="let grade of grades">{{ grade.grade }}</option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Fuel Type</label>
              <select formControlName="fuel_type_id" class="form-control">
                <option value="">Select</option>
                <option [value]="fuel_type.id" *ngFor="let fuel_type of fuel_types">{{ fuel_type.type }}</option>
              </select>
            </div>

            <div class="col-md-4">
              <label class="form-label">Reorder Level<span style="color:red;">*</span></label>
              <input type="number" formControlName="reorder_level" class="form-control" />
              <span *ngIf="submitted && form.get('reorder_level')?.hasError('required')" style="color:red"> <strong>Please enter reorder level!</strong></span>
            </div>

            <div class="col-md-4 d-flex align-items-end">
              <button type="submit" class="btn btn-success me-2">
                {{ isEditing ? 'Update' : 'Add' }}
              </button>
              &nbsp;
              <button type="button" (click)="cancel()" class="btn btn-secondary">Cancel</button>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-8">
              <div class="row">

              </div>
          </div>
          <div class="col-md-4">
            <div class="row">
                <div class="col" style="margin-bottom: 5px;">
                    <input type="text" class="form-control" placeholder="Type make,model or fuel here to search..." (input)="onSearchTextChange($event)">
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <table class="table table-bordered table-hover">
            <thead class="table-light">
              <tr>
                <th>Model</th>
                <th>Grade</th>
                <th>Fuel</th>
                <th>Reorder Level</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of reorderLevels | searchReorderLevels: searchText | paginate: { itemsPerPage: 6, currentPage: page, totalItems: count }">
                <td>{{ r.vehicle_make }} {{ r.vehicle_model }}</td>
                <td>{{ r.vehicle_grade || '-' }}</td>
                <td>{{ r.fuel_type || '-' }}</td>
                <td>{{ r.reorder_level }}</td>
                <td>
                  <button (click)="edit(r)" class="btn btn-sm btn-outline-success me-2">Edit</button>
                  &nbsp;&nbsp;
                  <button (click)="delete($event,r.id)" class="btn btn-sm btn-outline-danger">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</section>
